import {
  mdiCreationOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCheckCircle,
  mdiAccount,
  mdiAccountCircle,
  mdiAccountCogOutline,
  mdiArrowLeft,
  mdiCalendar,
  mdiCalendarRange,
  mdiChevronDown,
  mdiChevronUp,
  mdiClockOutline,
  mdiClose,
  mdiContentCopy,
  mdiContentSave,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiDownload,
  mdiEmoticonHappy,
  mdiEmoticonNeutral,
  mdiEmoticonSad,
  mdiEyeOutline,
  mdiFilterVariant,
  mdiFormatBold,
  mdiFormatHeader1,
  mdiFormatHeader2,
  mdiFormatHeader3,
  mdiFormatItalic,
  mdiFormatListBulleted,
  mdiFormatListNumbered,
  mdiFormatQuoteClose,
  mdiFormatStrikethrough,
  mdiFormatUnderline,
  mdiHeadset,
  mdiHelpCircle,
  mdiInboxMultiple,
  mdiMagnify,
  mdiMessageOutline,
  mdiMessageText,
  mdiMessageTextOutline,
  mdiPaperclip,
  mdiPhoneIncoming,
  mdiPhoneOutgoing,
  mdiReply,
  mdiReplyAll,
  mdiRedo,
  mdiSend,
  mdiTagText,
  mdiTranscribe,
  mdiUndo,
  mdiChartBar,
  mdiShare,
  mdiEmailEdit,
  mdiPlus,
  mdiSignatureFreehand,
} from '@mdi/js'
import type { VuetifyOptions } from 'vuetify'

export const vuetifyOptions: VuetifyOptions = {
  defaults: {
    VAutocomplete: {
      density: 'comfortable',
    },
    VDialog: {
      persistent: true,
      maxWidth: '50rem',
    },
    VSelect: {
      density: 'comfortable',
    },
    VMenu: {
      transition: 'menu-pop',
      openDelay: 20,
      closeDelay: 50,
    },
    VTooltip: {
      contentClass: 'shadow',
      transition: 'fade-transition',
      openDelay: 0,
      closeDelay: 0,
    },
  },
  icons: {
    aliases: {
      timer: mdiClockOutline,
      snooze: mdiClockOutline,
      tag: mdiTagText,
      save: mdiContentSave,
      calendar: mdiCalendar,
      calendarRange: mdiCalendarRange,
      chevronDown: mdiChevronDown,
      chevronUp: mdiChevronUp,
      checkboxBlankOutline: mdiCheckboxBlankOutline,
      checkboxMarked: mdiCheckboxMarked,
      success: mdiCheckCircle,
      transcribe: mdiTranscribe,
      aiMagic: mdiCreationOutline,
      detailsMenu: mdiDotsVertical,
      download: mdiDownload,
      copy: mdiContentCopy,
      preview: mdiEyeOutline,

      agent: mdiHeadset,
      phoneIn: mdiPhoneIncoming,
      phoneOut: mdiPhoneOutgoing,

      happyFace: mdiEmoticonHappy,
      neutralFace: mdiEmoticonNeutral,
      sadFace: mdiEmoticonSad,

      inboxAll: mdiInboxMultiple,
      sms: mdiMessageText,
      unknown: mdiHelpCircle,
      arrowLeft: mdiArrowLeft,

      search: mdiMagnify,
      filter: mdiFilterVariant,
      close: mdiClose,
      delete: mdiDeleteOutline,
      attachment: mdiPaperclip,
      reply: mdiReply,
      replyAll: mdiReplyAll,
      forward: mdiShare,
      send: mdiSend,
      account: mdiAccount,
      accountCircle: mdiAccountCircle,
      accountCog: mdiAccountCogOutline,
      messageOutline: mdiMessageOutline,
      messageTextOutline: mdiMessageTextOutline,
      editorBold: mdiFormatBold,
      editorItalic: mdiFormatItalic,
      editorUnderline: mdiFormatUnderline,
      editorStrike: mdiFormatStrikethrough,
      editorHeading1: mdiFormatHeader1,
      editorHeading2: mdiFormatHeader2,
      editorHeading3: mdiFormatHeader3,
      editorBullets: mdiFormatListBulleted,
      editorNumbers: mdiFormatListNumbered,
      editorQuote: mdiFormatQuoteClose,
      editorUndo: mdiUndo,
      editorRedo: mdiRedo,

      chartBar: mdiChartBar,
      template: mdiEmailEdit,
      plus: mdiPlus,
      signature: mdiSignatureFreehand,
    },
  },
}
